import { css } from '@emotion/react';
import { Trans, useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { RegisterTerminalModalStripeSteps } from '../hooks';
import {
  RegisterTerminalModalStepProps,
  RegisterTerminalStepModalWrapper,
  RegisterTerminalStep,
} from '../register-terminal-modal-step';

const styles = {
  list: css`
    list-style-type: number;
    padding-left: ${theme.spacing(2)};
    margin-top: ${theme.spacing(2)};
    margin-bottom: ${theme.spacing(1)};
    & > li:not(:first-of-type) {
      margin-top: ${theme.spacing(2)};
    }
    & > li:not(:last-of-type) {
      margin-bottom: ${theme.spacing(2)};
    }
  `,
  italicText: css`
    color: ${theme.font.colors.light};
  `,
};

export const OpenWifiSettings = (props: RegisterTerminalModalStepProps) => {
  const { t } = useTranslation('payments');
  return (
    <RegisterTerminalStepModalWrapper
      title={t('Open WiFi Settings')}
      nextStep={RegisterTerminalModalStripeSteps.ConnectToNetwork}
      Action={RegisterTerminalStep.Next}
      {...props}
    >
      <ol css={styles.list}>
        <li>{t('Ensure that your terminal is powered on and complete any available software updates')}</li>
        <li>{t('Swipe from the left side of the screen to the right side to open the menu')}</li>
        <li>{t('Tap Settings')}</li>
        <li>{t('Enter the Admin PIN 07139')}</li>
        <li>{t('Tap Wi-Fi Settings')}</li>
      </ol>
    </RegisterTerminalStepModalWrapper>
  );
};

export const ConnectToNetwork = (props: RegisterTerminalModalStepProps) => {
  const { t } = useTranslation('payments');

  return (
    <RegisterTerminalStepModalWrapper
      title=''
      nextStep={RegisterTerminalModalStripeSteps.GeneratePairingCode}
      Action={RegisterTerminalStep.Continue}
      {...props}
    >
      <ol css={styles.list}>
        <li>
          <Trans t={t}>
            Tap the name of your secure or private WiFi network
            <br />
            <i css={styles.italicText}>
              Ensure the network you connect your terminal to is the same network your desktop application is connected
              to
            </i>
          </Trans>
        </li>
        <li>{t('Enter your WiFi password using the digital keyboard at the bottom of the display screen')}</li>
        <li>{t('Tap Connect')}</li>
        <li>
          {t(
            'Once connected to Wi-Fi, tap the back arrow at the bottom of the screen for options to either change WiFi or update the terminal.'
          )}
        </li>
      </ol>
    </RegisterTerminalStepModalWrapper>
  );
};
